import { createFileRoute, Outlet } from "@tanstack/react-router"

import { createMembersUiStore } from "@/lib/stores/members-ui-store"

export const Route = createFileRoute("/_authed/_admin/members")({
  context: () => ({
    membersStore: createMembersUiStore(),
  }),
  component: Outlet,
})
